import styled from 'styled-components';

export const SubAccountCellWrapper = styled.div`
  a[href] {
    color: ${({ theme }) => theme.color.mainDark};
    text-decoration: underline;
  }
`;
